// action type and its name defined here as common
export const AuthActionType = {
  getUserLoginDetails: "GET_USER_LOGIN_DETAILS",
  getTokenDetails: "GET_TOKEN_DETAILS",
  getClientLogo: "GET_CLIENT_LOGO",
};

export const CommonActionType = {
  getBranchList: "GET_BRANCH_LIST",
  getJobtitleList: "GET_JOBTITLE_LIST",
  getShiftList: "GET_SHIFT_LIST",
  getCategoryList: "GET_CATEGORY_LIST",
  getSkillsList: "GET_SKILLS_LIST",
  getCustomerList: "GET_Customer_LIST",
};

export const AppointmentActionType = {
  customerDetail: "CUSTOMER_DETAIL",
  appointmentDetail: "APPOINTMENT_DETAIL",
  getTreatmentDetail: "GET_TREATMENT_DETAIL",
  getOutletDetail: "GET_OUTLET_DETAIL",
  getSelectedTreatmentList: "GET_SELECTED_TREATMENT_LIST",
  getConfirmedBookingList: "GET_CONFIRMED_BOOKING_LIST",
  getBookAppointmentList: "GET_BOOK_APPOINTMENT_LIST",
  getAppointmentCartList: "GET_APPOINTMENT_CART_LIST",
  //Added by Santhosh
  getSite: "GET_SITE_ID",
  getSiteCode: "GET_SITE_CODE",
};

export const StaffActionType = {
  getStaffDetail: "GET_STAFF_DETAIL",
};

export const StaffPlusActionType = {
  getStaffPlusDetail: "GET_STAFF_PLUS_DETAIL",
  getStaffPlusWorkSchedule: "GET_STAFF_PLUS_WORK_SCHEDULE",
  getStaffPlusSchedule: "GET_STAFF_PLUS_SCHEDULE",
  getStaffPlusAllEmpSchedule: "GET_STAFF_PLUS_ALL_EMP_SCHEDULE",
  getStaffPlusSkillList: "GET_STAFF_PLUS_SKILL_LIST",
  getEmpEmpSkillList: "GET_EMP_SKILL_LIST",
  getAuthorizationSettings: "GET_AUTHORIZATION_SETTINGS",
  getIndividualAuthorizationSettings: "GET_INDIVIDUAL_AUTHORIZATION_SETTINGS",
};

export const SaloonActionType = {
  getSaloonDetail: "GET_SALOON_DETAIL",
};

export const ServicesActionType = {
  getServicesDetail: "GET_SERVICES_DETAIL",
};

export const PaymentActionType = {
  getPaymentDetail: "GET_PAYMENT_DETAIL",
};

export const CustomerActionType = {
  getCustomerDetail: "GET_CUSTOMER_DETAIL",
};

export const CustomerPlusActionType = {
  getCustomerPlusDetail: "GET_CUSTOMER_PLUS_DETAIL",
  getCustomerPlusSettings: "GET_CUSTOMER_PLUS_SETTINGS",
  getRewardPolicySettings: "GET_REWARD_POLICY_SETTINGS",
  getRedeemPolicySettings: "GET_REDEEM_POLICY_SETTINGS",
  getCustomerPoints: "GET_CUSTOMER_POINTS",
  getDiagnosisPhotos: "GET_DIAGNOSIS_PHOTOS",
  getDiagnosisHistory: "GET_DIAGNOSIS_HISTORY",
  getMGMDetails: "GET_MGM_DETAILS",
};

export const KPIActionType = {
  getDailyCollections: "GET_DAILY_COLLECTIONS",
  getMonthlyCollections: "GET_MONTHLY_COLLECTIONS",
  getConsultantCollections: "GET_CONSULTATNT_COLLECTIONS",
  getRankingByOutlet: "GET_RANKING_BY_OUTLET",
  getConsultantServiceRanking: "GET_CONSULTATNT_SERVICE_RANKING",
  getConsultantSalesRanking: "GET_CONSULTATNT_SALES_RANKING",
};

// action type and its name defined here as common

export const ProjectActionType = {
  getProjectListing: "GET_PROJECT_LISTING",
};

export const QuotationActionType = {
  getProjectListing: "GET_PROJECT_LISTING",
};

export const ManualInvoiceActionType = {
  getProjectListing: "GET_PROJECT_LISTING",
};

export const WorkOrderInvoiceActionType = {
  getProjectListing: "GET_PROJECT_LISTING",
};

export const POActionType = {
  getProjectListing: "GET_PO",
};

export const TransactionHistoryType = {
  getTransactionHistory: "GET_TRANSACTION_HISTORY",
  getTransactionPageNum: "GET_TRANSACTION_PAGENUM",
  getTransactionSetting: "GET_TRANSACTION_SETTING",
  getTransactionSettingList: "GET_TRANSACTION_SETTING_LIST",
  getTransactionOrderChange: "GET_TRANSACTION_ORDER_CHANGE",
};

export const DiscountType = {
  getDiscount: "GET_DISCOUNT",
};

// export const PayModeType = {
//   getPaymode: "GET_PAY_MODE",
// };
